<section class="modal-success-container">
  <div class="modal-header">
    <img
      ngSrc="../../../../assets/bootstrap_icons/check2.svg"
      width="75"
      height="75"
      alt="success"
    />
  </div>
  <div class="modal-body text-center">
    <p class="fw-bold">{{ "front.success-modal.success" | translate }}</p>
    <p>{{ description | translate }}</p>
  </div>
</section>
